import { NUTBaseApi, NUTBaseApiAffiliateRequest } from "./AppApiManager";

/**
 * The NUT-service client for the viewer's role. Role 1 (a customer) calls
 * with their own token; any other role is an affiliate viewing a client, so
 * the request carries the client token minted into this tab — the same
 * switch `getHomePage` in `Api.ts` uses. Shared by the plan APIs
 * (`nutritionPlanApi`, `workoutPlanApi`).
 */
export const nutClientForRole = async (role: number) =>
  role === 1 ? NUTBaseApi() : NUTBaseApiAffiliateRequest();
